import React,{useEffect, useState} from 'react';
import { useHistory } from 'react-router-dom';

export default function GoogleAnalytics () {
    
    const history = useHistory();

    useEffect (
        
        () => {
            console.log('ga eff');
          history.listen((location, action) => {
            console.log(`The current URL is ${location.pathname}${location.search}${location.hash}`);
            console.log(`The last navigation action was ${action}`);
            window.gtag('config', 'UA-179155393-1', { 'page_path': '/admin'+ location.pathname });            
          })   
          //ilk yuklendiginde event tetiklenmiyor diye burada bir kere daha cagiriyorum
          window.gtag('config', 'UA-179155393-1', { 'page_path': '/admin'+ window.location.pathname });            
        },[]
      )
    
    return null;
}
